import React, {PropTypes} from "react";
import AnnouncementForm from "./components/AnnouncementCreateForm";


class AnnouncementsHomePage extends React.Component {

  constructor() {
    super();
    this.state = {mrange: {from: {year: 2017, month: 1}, to: {year: 2019, month: 12}}}
    this.handleRangeDissmis = this.handleRangeDissmis.bind(this);
  }
  componentDidMount()
  {
    this.props.changeBanner("Create New");
  }
  handleRangeDissmis(value) {
    this.setState({mrange: value})
  }

  render() {
    let pickerLang = {
      months: ['Jan', 'Feb', 'Mar', 'Spr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      , from: 'From', to: 'To'
    }
      , mvalue = {year: 2015, month: 11}
      , mrange = {from: {year: 2014, month: 8}, to: {year: 2015, month: 5}}

    let makeText = m => {
      if (m && m.year && m.month) return (pickerLang.months[m.month - 1] + '. ' + m.year)
      return '?'
    }

    return (
      <div className="col-md-12">


        <br/>


          <AnnouncementForm/>



      </div>
    );
  }
}

AnnouncementsHomePage.defaultProps = {}

AnnouncementsHomePage.propTypes = {};

export default AnnouncementsHomePage;





/** WEBPACK FOOTER **
 ** ./src/feature/announcements/AnnouncementsCreateNew.js
 **/